import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';
import { 
  Layout,
  Col, 
  Row,
  Dropdown, 
  Space,
  Modal,
  Button,
  Form,
  Input,
  Tabs,
  DatePicker,
  Radio,
  InputNumber,
} from 'antd';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { formatDate, getUserRole, formatAmount, extractAmount, getTodayDateISO, validateSpaces } from '../../Utils/Common';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Item } = Form;
const { Search } = Input;
const { confirm } = Modal;

const ConstructionBonds = () => {
  const role_name = getUserRole()
  const [addVisible, setAddVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [constructionId, setConstructionId] = useState('');
  const [excelData, setExcelData] = useState([])
  const [totalAmount, setTotalAmount] = useState(0);
  const [constructionData, setConstructionData] = useState([])

  const [filterConfig, setFilterConfig] = useState({
    date_from: "",
    date_to: "",
    search: "",
    status: "active",
    page: 1,
  })

  const [form] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    form.resetFields();
    fetchConstructionData()
    setAddVisible(false)
  });

  async function fetchConstructionData() {
    setIsLoading(true);
    const response = await UseGetRequest("construction_bonds/get", filterConfig);
    if (response.data) {
      const deposits_date = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_id: data.tenant_id,
        amount: formatAmount(data.amount),
        date_paid: formatDate(data.date_paid),
        remarks: data.remarks,
        refunded_amount: data.refunded_amount,
        refunded_on: data.refunded_on,
        refund_remarks: data.refund_remarks,
        status: data.status,
        tenant_name: data.tenant_name,
        property_name: data.property_name,
        rental_unit_name: data.rental_unit_name,
      }))
      setTotalAmount(response?.data?.total)
      setPageSize(response?.data?.size)
      setConstructionData(deposits_date);
    } else {
      setTotalAmount(0)
      setPageSize('')
      setConstructionData([])
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true);
    const response = await UseGetRequest("construction_bonds/get", 
      {
        date_from: filterConfig.date_from,
        date_to: filterConfig.date_to,
        search: filterConfig.search,
        status: filterConfig.status,
      }
    );
    if (response.data) {
      const data = response?.data?.data?.map((data) => ({
        id: data.id,
        tenant_name: data.tenant_name,
        property_name: data.property_name,
        rental_unit_name: data.rental_unit_name,
        amount: data.amount && formatAmount(data.amount),
        date_paid: data.date_paid && formatDate(data.date_paid),
        payment_type: data.payment_type,
        refund_remarks: data.refund_remarks,
        refunded_amount: data.refunded_amount && formatAmount(data.refunded_amount),
        refunded_on: data.refunded_on && formatDate(data.refunded_on),
        check_no: data.check_no,
        check_date: data.check_date && formatDate(data.check_date),
        check_bank: data.check_bank,
        status: data.status,
        remarks: data.remarks,
        added_on: data.added_on,
        updated_on: data.updated_on,
      }))
      
      setExcelData(data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const showAddModal = (data) => {
    setAddVisible(true);
    if(data){
      setConstructionId(data?.id)
      form.setFieldsValue({
        refunded_amount: data?.amount || "",
      });
    }
  };

  const handleAddOk = () => {
    form.validateFields().then(values => {
      const resetData = {
        construction_bond_id: constructionId,
        refunded_amount: typeof values.refunded_amount === 'string' ? extractAmount(values?.refunded_amount) : values?.refunded_amount,
        payment_type: paymentMethod,
      };

      if(paymentMethod === "check"){
        resetData.check_no = values?.check_no;
        resetData.check_bank = values?.check_bank;
        resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
      }

      if(paymentMethod === "others"){
        resetData.refund_remarks = values?.refund_remarks;
      }

      resetData.refunded_on = values?.refunded_on ? values.refunded_on.format("YYYY-MM-DD") : "";

      callPost(
          "construction_bonds/refund", 
          resetData,
          false,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleAddCancel = () => {
    setAddVisible(false);
  };

  const onMethodChange = ({ target: { value } }) => {
    setPaymentMethod(value);
  };

  const options = [
    {
      label: 'Cash',
      value: 'cash',
    },
    {
      label: 'Check',
      value: 'check',
    },
    {
      label: 'Other',
      value: 'others',
    },
  ];

  function ActionBtn(row) {
    const items = [
      {
        key: '4',
        label: (
          <div onClick={() => showAddModal(row.row)}>
              Refund
          </div>
        ),
      },
    ];

    return (
      <>
        {
        (row.row.status !== "refunded") && (
          <span className='center'>
            <Dropdown
              menu={{
              items,
              }}
              trigger={['click']}
            >
              <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
                <Space>
                  <MoreVert />
                </Space>
              </div>
            </Dropdown>
          </span>
        )
        }
      </>
    );
  }

  function RefundBtn(row) {
    return (
      <Row>
        <Col className='center'>
          <Button 
            className='approve-btn'
            onClick={() => handleForApproval({id: row.row.id, action:"approve"})}
          >
            Approve
          </Button>
        </Col>
        <Col className='center'>
          <Button 
            className='disapprove-btn'
            onClick={() => handleForApproval({id:row.row.id, action:"disapprove"})}
          >
            Disapprove
          </Button>
        </Col>
      </Row>
    );
  }

  const handleForApproval = (data) => {
    confirm({
      title: `Are you sure you want to ${data.action === "approve" ? "approve" : "disapprove"}?`,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      cancelText: 'No',
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      onOk() {
        if(data){
          const resetData = {
            construction_bond_id: data.id,
            action: data.action
          };

          callPost(
            "construction_bonds/refund_action", 
            resetData,
            false,
          );
        }
      },
    });
  };

  const onSearchDate = (e) => {
    if(e){
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: e[0].format("YYYY-MM-DD"),
          end_date: e[1].format("YYYY-MM-DD"),
          page: 1,
        }
      ));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
    }
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onChange = (activeKey) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        status:  activeKey
      }
    ));
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchConstructionData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'construction_bonds_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
            CONSTRUCTION BOND
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Name",
                  "Property",
                  "Unit Number",
                  "Amount",
                  "Date Paid",
                  "Payment Type",
                  "Refund Remarks",
                  "Refunded Amount",
                  "Refunded On",
                  "Check No",
                  "Check Date",
                  "Checl Bank",
                  "Status",
                  "Remarks",
                  "Added On",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Construction_Bond_${getTodayDateISO()}.xlsx`}
              />    
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24} className='excel-row'>
            <Space className='responsive-inline'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />     
              <RangePicker 
                renderExtraFooter={() => 'extra footer'} 
                className='responsive-header-input'
                onChange={(e)=>onSearchDate(e)}
              />
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='amount-total pe-4' align='right'>
            Total Amount: {formatAmount(totalAmount)}
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <Tabs 
              defaultActiveKey="active" 
              type="card" 
              className="custom-tabs" 
              onChange={onChange}
            >
              <TabPane tab="Active" key="active">
                <AntDTable
                  tableHeaders={[
                    "Doc No.",
                    "Tenant Name",
                    "Building & Unit Number",
                    "Unit Number",
                    "Payment Date",
                    "Amount",
                  ]}
                  headerSelector={[
                    "id",
                    "tenant_name",
                    "property_name",
                    "rental_unit_name",
                    "date_paid",
                    "amount",
                  ]}
                  tableData={constructionData}
                  ActionBtn={(row) => ActionBtn(row)}
                  withAction={true}
                  loading={isLoading}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
              <TabPane tab="For Approval" key="for_approval">
                <AntDTable
                  tableHeaders={[
                    "Doc No.",
                    "Tenant",
                    "Building & Unit Number",
                    "Unit Number",
                    "Refund Date",
                    "Refunded Amount",
                    "Remarks",
                  ]}
                  headerSelector={[
                    "id",
                    "tenant_name",
                    "property_name",
                    "rental_unit_name",
                    "date_paid",
                    "refunded_amount",
                    "refund_remarks",
                  ]}
                  tableData={constructionData}
                  ActionBtn={(row) => RefundBtn(row)}
                  withAction={role_name === "Administrator"}
                  loading={isLoading}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
              <TabPane tab="Refunded" key="refunded">
                <AntDTable
                  tableHeaders={[
                    "Doc No.",
                    "Tenant",
                    "Building & Unit Number",
                    "Unit Number",
                    "Refund Date",
                    "Refund Amount",
                    "Remarks",
                  ]}
                  headerSelector={[
                    "id",
                    "tenant_name",
                    "property_name",
                    "rental_unit_name",
                    "date_paid",
                    "refunded_amount",
                    "refund_remarks",
                  ]}
                  tableData={constructionData}
                  // ActionBtn={(row) => ActionBtn(row)}
                  // withAction={true}
                  loading={isLoading}
                  tablePages={10}
                  handleTableChange={handleTableChange}
                  filterConfig={filterConfig}
                  totalSize={pageSize}
                  isSearch={true}
                />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Layout>
      <Modal
        title="Construction Bonds Refund"
        open={addVisible}
        onOk={handleAddOk}
        confirmLoading={loading}
        onCancel={handleAddCancel} 
      >
        <Form form={form} layout="vertical">
          <Item
            label="Amount (Php) "
            name="refunded_amount"
            rules={[{ required: true, message: 'Please enter your Amount!' }]}
          >
            <InputNumber  style={{width:'100%'}}/>
          </Item>
          <Item
            label="Date Paid"
            name="refunded_on"
            rules={[{ required: true, message: 'Please enter your Date Paid!' }]}
          >
            <DatePicker style={{width:'100%'}}/>
          </Item>
          <Radio.Group 
            options={options} 
            onChange={onMethodChange} 
            value={paymentMethod} 
            optionType="button" 
            className='mb-4'
          />
          {
            paymentMethod === "check" && (
              <>
                <Item
                  label="Bank Name"
                  name="check_bank"
                  rules={
                    [
                      { required: true, message: 'Please enter your Bank Name!' },
                      { validator: validateSpaces }
                    ]
                  }
                >
                  <Input/>
                </Item>
              
                <Item
                  label="Check Date"
                  name="check_date"
                  rules={[{ required: true, message: 'Please enter your Check Date!' }]}
                >
                  <DatePicker style={{width:'100%'}}/>
                </Item>
              
                <Item
                  label="Check Number"
                  name="check_no"
                  rules={[
                    { required: true, message: 'Please enter your Check Number!' },
                    { validator: validateSpaces },
                  ]}
                >
                  <Input/>
                </Item>
              </>
            )
          }
          {
            paymentMethod === "others" && (
              <Item
                label="Remarks"
                name="refund_remarks"
              >
                <Input/>
              </Item>
            )
          }
        </Form>
      </Modal>
    </Layout>
  )
}

export default ConstructionBonds
